import { Box, Button, Menu, SpeedDialAction, Tooltip, tooltipClasses } from "@mui/material";
import { styled as muiStyled } from '@mui/material/styles';
import { primary100 } from "styles/theme";
import { dark } from "styles/theme";

export const printPageStyle = `
                @page { size: landscape; }
                @media print { body { direction: rtl; } }
                `

export const FilterManagerStyles = muiStyled(Box)(({ advancedFiltersCount, isExpanded, color, borderStyle = "solid", borderColor }) => ({
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: "100%",
    '.search-input': {
        display: "flex",
        columnGap: 10
    },
    '.search-button': {
        display: "flex",
        alignItems: "center",
        '.MuiButton-root': {
            background: "#F2F4F7"
        }
    },
    '.expanded-filters-on': {
        '& .MuiButtonBase-root.MuiButton-root': {
            background: "#F2F4F7 !important"
        }
    },
    '.line': {
        height: 35,
        width: 1,
        background: primary100
    },
    'i': {
        fontSize: 14
    },
    '.wrap-filters': {
        flexGrow: 1
    },
    '.filters': {
        display: "flex",
        columnGap: 10,
        alignItems: 'center',
    },
    '.advanced-filters': {
        height: 65,
        overflowX: "auto"
    },
    '.primary-filters': {
        width: "100%",
        display: 'flex',
        columnGap: 10,
        justifyContent: "space-between",
        flexWrap: 'wrap',
        alignItems: 'center',
        height: 70, // קיבוע גובה למניעת רעידות
        width: '100%'
    },

    '.table-header-buttons': {
        display: "flex",
        columnGap: 6,
        alignItems: "center",
        // '.MuiButtonBase-root.MuiButton-root': {
        //     background: advancedFiltersCount ? "#F2F4F7" : "white",
        //     border: `1px solid #E3E8F0`,
        //     color: dark,
        //     display: "flex",
        //     columnGap: advancedFiltersCount ? 4 : 7,
        //     paddingLeft: 8,
        //     paddingRight: 8,
        //     alignItems: "center",
        //     borderRadius: 8,
        //     height: 35
        // },

        '.MuiButtonBase-root.MuiIconButton-root': {
            background: "white",
            border: `1px solid #E3E8F0`,
            color: dark,
            borderRadius: 8,
            height: 35,
            width: 35
        }
    }
}));


export const AdvancedButtonStyles = muiStyled(Button)(({ height, advancedFiltersCount, isExpanded, color, borderStyle = "solid", borderColor }) => ({
    background: advancedFiltersCount ? "#F2F4F7" : "white",
    border: `1px solid #E3E8F0`,
    color: dark,
    display: "flex",
    columnGap: advancedFiltersCount ? 4 : 7,
    paddingLeft: 8,
    paddingRight: 8,
    alignItems: "center",
    borderRadius: 8,
    height: height ? height : "auto",
    '&:hover': {
        background: advancedFiltersCount ? "#F2F4F7" : "white",
        opacity: 0.9
    },
    '.MuiButtonBase-root.MuiIconButton-root': {
        background: "white",
        border: `1px solid #E3E8F0`,
        color: dark,
        borderRadius: 8,
        height: 35,
        width: 35
    }
}));